import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1 } from '../../StyledComponents';

const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  // background-color: #03103b;
  padding-bottom: 96px !important;
  padding-top: 96px !important;
  // max-width:800px;
`;
const SectionTitle = styled(H1)`
  padding: 0 0 20px;
  color: #765ebf;
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  @media (max-width: 520px) {
    text-align: center;
    width: 80%;
    // padding: 1rem 0;
    padding-bottom: 0;
  }
`;
const Rectangle = styled.div`
  width: 80%;
  max-width: 650px;
  padding: 1.5rem;
  // text-align:center;
  // max-height: 100px;
  background-color: #298de5;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  border-radius: 5rem;
  text-align: center;
  color: #fff;
  background-color: #765ebf;
  @media (max-width: 768px) {
    border-radius: 3rem;
  }
`;
const RectangleTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const MiddleText = styled.span`
  padding: 0 0 1rem;
  color: #4f5263;
  font-size: 18px;
  margin-bottom: 1rem;
  max-width: 460px;
  text-align: center;
`;

export default () => (
  <>
    <Section>
      <SectionTitle> Interested in taking the next step? </SectionTitle>
      <MiddleText>
        Esper is continually evaluating qualified partnerships who are in the
        business of enterprise Android solutions.
      </MiddleText>
      <Rectangle>
        <RectangleTitle>
          As an Esper Partner, You’ll Be in Great Company.
        </RectangleTitle>
        Some of the world’s best-known brands have already teamed up with Esper.
      </Rectangle>
    </Section>
  </>
);
